import React from "react";

export default function FieldPriority_PopoverMore(props:any) {

    const onClick = () => {
        props.parent.hidePopover();
        gd.goTo('settings/priorities');
    }

    return (
        <div className="help">
            <div className="flex-row-left-center" onClick={onClick}>
                <div className="ui5-ico-15 i5-wrench m-r-8" />
                <div className="ui5-txt-link-small-no-accent" >Manage priorities</div>
            </div>

        </div>

    );
}